/**
 * Read a v2 endpoint and throw when it did not work.
 *
 * `if (d.success) setX(...)` with no else turned every failure into an empty
 * state: on the deployed dev site the PIN cookie was not sent, every gated
 * route answered 401, and Ratkaisut said "Vipupisteitä ei ole vielä johdettu"
 * about a map that had seventeen. A failed read throws here, with the server's
 * own message, so the screen's ErrorBox shows what actually happened.
 */
export async function v2Json(url, init = {}) {
  const res = await fetch(url, { credentials: 'include', ...init });
  const data = await res.json().catch(() => null);
  if (!res.ok || !data || data.success === false) {
    const message = data?.error?.message || data?.error || `HTTP ${res.status}`;
    const err = new Error(typeof message === 'string' ? message : JSON.stringify(message));
    err.status = res.status;
    err.code = data?.error?.code || null; // e.g. STALE_VERSION, JUDGEMENTS_LOCKED
    throw err;
  }
  return data;
}
